import { FeatureSwitchKey } from '../models/feature-switches';
import { getFeatureSwitchValue } from '../utils/feature-switch-utils';

export type TFeatureSwitches = {
  [key in FeatureSwitchKey]: string | number | boolean | null;
};

export const FeatureSwitches: TFeatureSwitches = {
  /**
   * Purchase History Feature Switches:
   * - enableAndroidReceiptScanner - Enable Android Receipt Scanner
   * - OMS_VIEW_BIG_RECEIPT_SWITCH - enables the new OMS view big receipt

   * - allowViewSorisQrCode - allows the view of the SORIS QR code
   * - allowNativeAppInStoreReceiptPrint - allows native app in store receipt print
   */
  OMS_VIEW_BIG_RECEIPT_SWITCH: getFeatureSwitchValue('enableOMSViewBigReceipt'),
  allowNativeAppInStoreReceiptPrint: getFeatureSwitchValue(
    'allowNativeAppInStoreReceiptPrint',
  ),
  enableNewLoyaltySpendUI: getFeatureSwitchValue(
    'enableNewLoyaltySpendUI',
    true,
  ),

  /**
   * Order Details Feature Switches:
   */
  remorseCancelPeriod: getFeatureSwitchValue('remorseCancelPeriod'),
  proSiteInstructionsMAEnabled: getFeatureSwitchValue(
    'proSiteInstructionsMAEnabled',
  ),
  enableChargedDetailsView: getFeatureSwitchValue(
    'enableChargedDetailsView',
    true,
  ),

  /**
   * Start A Returns Feature Switches:
   * allowSTHUndeliveredReturns - allows STH undelivered returns
   */
  allowSTHUndeliveredReturns: getFeatureSwitchValue(
    'allowSTHUndeliveredReturns',
    true,
  ),
  allowViewSorisQrCode: getFeatureSwitchValue('allowViewSorisQrCode', true),
  allowSORISCancel: getFeatureSwitchValue('allowSORISCancel', true),
  allowTrackingNumBasedShipments: getFeatureSwitchValue(
    'allowTrackingNumBasedShipments',
    true,
  ),
  CXO_UPS_DEPLOYMENT_DATE: getFeatureSwitchValue(
    'CXO_UPS_DEPLOYMENT_DATE',
    true,
  ),
  disableStartAReturn: getFeatureSwitchValue('disableStartAReturn', true),
  enableP0ReturnReceiptBarcode: getFeatureSwitchValue(
    'enableP0ReturnReceiptBarcode',
    true,
  ),

  enableMACancelReasonCodes: getFeatureSwitchValue('enableMACancelReasonCodes'),

  ptcBectran: getFeatureSwitchValue('ptcBectran'),
  enableCPSSearch: getFeatureSwitchValue('enableCPSSearch', true),
  enableBopisOutOfStockRecoverability: getFeatureSwitchValue(
    'enableBopisOutOfStockRecoverability',
  ),
  enableModPTC: getFeatureSwitchValue('enableModPTC', true),
  enableProjectName: getFeatureSwitchValue('enableProjectName', true),
  enableEditDeliveryAddressAppify: getFeatureSwitchValue(
    'enableEditDeliveryAddressAppify',
  ),
  enableDeliveryTrackerReturnChanges: getFeatureSwitchValue(
    'enableDeliveryTrackerReturnChanges',
    true,
  ),
  enableBodfsDfsSoris: getFeatureSwitchValue('enableBodfsDfsSoris', true),
  enableReturnsScheduledPickup: getFeatureSwitchValue(
    'enableReturnsScheduledPickup',
    true,
  ),
  enableBopisOutOfStockSubstitution: getFeatureSwitchValue(
    'enableBopisOutOfStockSubstitution',
  ),
  enableCPSAnnouncementBanner: getFeatureSwitchValue(
    'enableCPSAnnouncementBanner',
  ),
  enableRefundBreakdown: getFeatureSwitchValue('enableRefundBreakdown'),
  enableNativeWallet: getFeatureSwitchValue('enableNativeWallet'),
  enableBopisOutOfStockFfaLiteCall: getFeatureSwitchValue(
    'enableBopisOutOfStockFfaLiteCall',
  ),
  isBOPISToBODFSEnabled: getFeatureSwitchValue('isBOPISToBODFSEnabled', true),
  enablePTCLineOfCredit: getFeatureSwitchValue('enablePTCLineOfCredit'),
  isSFBLEnabled: getFeatureSwitchValue('isSFBLEnabled'),
  enableLSSCPS25MonthsDefault: getFeatureSwitchValue(
    'enableLSSCPS25MonthsDefault',
    true,
  ),
  checkCancelEligibilityOnFetchOrder: getFeatureSwitchValue(
    'checkCancelEligibilityOnFetchOrder',
  ),
  enableEmbeddedBatteryFee: getFeatureSwitchValue('enablePHEmbeddedBatteryFee'),
  enableCPSOrderLevelSearch: getFeatureSwitchValue('enableCPSOrderLevelSearch'),
  enablePOJOBAndPaymentSearch: getFeatureSwitchValue(
    'enablePOJOBAndPaymentSearch',
  ),
  enableAddItemsFakeDoorFS: getFeatureSwitchValue('enableAddItemsFakeDoorFS'),
  enableAssignProjectDrawer: getFeatureSwitchValue('enableAssignProjectDrawer'),
  enableB2CReorderRecommendations: getFeatureSwitchValue(
    'enableB2CReorderRecommendations',
  ),
};
